"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReactRouterApp = void 0;
var tslib_1 = require("tslib");
var react_core_1 = require("@slicesjs/react-core");
var reactive_map_1 = require("@slicesjs/reactive-map");
var history_1 = require("history");
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = require("react-dom");
var react_error_boundary_1 = require("react-error-boundary");
var GenericRouter_1 = require("./GenericRouter");
var DefaultSliceRoot = function (_a) {
    var children = _a.children;
    return children;
};
/** It creates a mount function to bridge a host and a slice that uses React Router navigations. */
var createReactRouterApp = function (
/** React-based slice to be mounted */
App, _a) {
    var historyProperty = _a.history, _b = _a.reactiveMap, defaultReactiveMap = _b === void 0 ? function () {
        return new reactive_map_1.ReactiveMap();
    } : _b, packageName = _a.packageName, onError = _a.onError, _c = _a.onPreMount, onPreMount = _c === void 0 ? function (_a) {
        var cleanups = _a.cleanups;
        return ({
            SliceRoot: DefaultSliceRoot,
            cleanups: cleanups,
        });
    } : _c;
    var history = historyProperty !== null && historyProperty !== void 0 ? historyProperty : (0, history_1.createMemoryHistory)();
    var mount = function (element, _a) {
        var _b = _a === void 0 ? {} : _a, onSliceNavigate = _b.onSliceNavigate, reactiveMap = _b.reactiveMap, basename = _b.basename, pathname = _b.pathname, scopedMap = _b.scopedMap, isSelfHosted = _b.isSelfHosted;
        // run onPreMount API callback before mounting
        var _c = onPreMount({
            cleanups: [],
            reactiveMap: reactiveMap,
            scopedMap: scopedMap,
            isSelfHosted: isSelfHosted,
        }), _d = _c.cleanups, cleanups = _d === void 0 ? [] : _d, _e = _c.SliceRoot, SliceRoot = _e === void 0 ? DefaultSliceRoot : _e;
        var initialPath = [basename, pathname].join('/').replace(/\/{2,}/g, '/');
        history.push("".concat(initialPath).concat(typeof window !== 'undefined' ? window.location.search : ''));
        // hook onSliceNavigate callback if it's defined
        if (onSliceNavigate) {
            cleanups.push(history.listen(function (e) {
                var _a = e.location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
                return onSliceNavigate(pathname, { hash: hash, search: search });
            }));
        }
        // mount root in element
        if (element) {
            (0, react_dom_1.render)(
            // Types from react-error-boundary are not compatible with ReactNode
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            react_1.default.createElement(react_error_boundary_1.ErrorBoundary, { onError: onError, fallbackRender: function (_a) {
                    var error = _a.error;
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("p", null,
                            "An error has occured in ",
                            packageName,
                            ":"),
                        react_1.default.createElement("p", null, error.message)));
                } },
                react_1.default.createElement(SliceRoot, null,
                    react_1.default.createElement(GenericRouter_1.GenericRouter, { history: history, basename: basename },
                        react_1.default.createElement(App, { reactiveMap: reactiveMap })))), element);
        }
        return {
            onHostNavigate: function (pathname) {
                var currentPathname = history.location.pathname;
                if (currentPathname !== pathname)
                    history.push(pathname);
            },
            unmount: function () {
                cleanups.forEach(function (cleanup) { return cleanup(); });
                if (element)
                    (0, react_dom_1.unmountComponentAtNode)(element);
            },
        };
    };
    var root = document.getElementById((0, react_core_1.getSliceName)(packageName, { root: true }));
    if (root) {
        //since it's being ran without a host we set the history as browser history
        // Ignore if history is passed in as an argument
        if (!historyProperty) {
            history = (0, history_1.createBrowserHistory)();
        }
        mount(root, {
            reactiveMap: typeof defaultReactiveMap === 'function'
                ? defaultReactiveMap()
                : defaultReactiveMap,
            scopedMap: new Map(),
            pathname: window.location.pathname,
            isSelfHosted: true,
        });
    }
    return { mount: mount };
};
exports.createReactRouterApp = createReactRouterApp;
//# sourceMappingURL=createReactRouterApp.js.map